import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import withAuth from '../../App/Authenticate';

const EventOverview = class EventOverview extends React.Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    return (
      <div>
        <Segment>
          {this.props.children}
        </Segment>
      </div>
    );
  }
};

export default withAuth(EventOverview);



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/EventOverviewComponent.js